import './Label.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var label = _7a468({defaultClassName:'_1gxatyo0-3-15-1',variantClassNames:{disabled:{true:'_1gxatyo1-3-15-1'},required:{true:'_1gxatyo2-3-15-1'},readOnly:{true:'_1gxatyo3-3-15-1'}},defaultVariants:{},compoundVariants:[]});
export var readOnlyLabel = '_1gxatyo4-3-15-1';